const EventTypeEnum = Object.freeze({
    DAILY_NOTIFICATION_REMINDER: 'DAILY_NOTIFICATION_REMINDER',
    INVESTOR_MEDIA_CREATED: 'INVESTOR_MEDIA_CREATED',
    INVESTOR_MEDIA_CREATED_MULTIPLE: 'INVESTOR_MEDIA_CREATED_MULTIPLE',
    INVESTOR_ACCOUNT_AUTHORISED: 'INVESTOR_ACCOUNT_AUTHORISED',
    PROPOSAL_CREATED: 'PROPOSAL_CREATED',
    PROPOSAL_STATUS_UPDATED: 'PROPOSAL_STATUS_UPDATED',
    PROPOSAL_COMPLETED: 'PROPOSAL_COMPLETED',
    SHORTLIST_NEEDS_ADVISER_FEES: 'SHORTLIST_NEEDS_ADVISER_FEES'
});

export default EventTypeEnum;
